import { useEffect } from 'react'
import { createPortal } from 'react-dom'

import {
  useChatIntro,
  useChatMutations,
  useFetchChatSessions,
  useHydrateSidebarCollapsed,
  useSidebarCollapsed,
  useSidebarWidth,
} from '../../hooks'
import CollapsedRail from './CollapsedRail'
import Expanded from './Expanded'
import MobileBackdrop from './MobileBackdrop'
import { useRightRailTarget } from './useRightRailTarget'

interface ChatSidebarProps {
  slug: string
}

export default function ChatSidebar({ slug }: ChatSidebarProps) {
  useFetchChatSessions(slug)
  useHydrateSidebarCollapsed(slug)
  const collapsed = useSidebarCollapsed()
  const width = useSidebarWidth()
  const { setSidebarCollapsed } = useChatMutations()
  const { dismissed: introDismissed, dismiss: dismissIntro } = useChatIntro()
  const target = useRightRailTarget()

  // Opening chat counts as "seen" — retire the intro nudge for good.
  useEffect(() => {
    if (!collapsed && !introDismissed) dismissIntro()
  }, [collapsed, introDismissed, dismissIntro])

  if (!target) return null

  const node = collapsed ? (
    <CollapsedRail
      slug={slug}
      onExpand={() => setSidebarCollapsed(false)}
      showIntro={!introDismissed}
      onDismissIntro={dismissIntro}
    />
  ) : (
    <>
      <MobileBackdrop onClose={() => setSidebarCollapsed(true)} />
      <Expanded slug={slug} width={width} />
    </>
  )

  return createPortal(node, target)
}
